<template>
  <modal-layout :is-open="isOpen" @close="modalClose">
    <div class="Modal_area Explanation__modal_area">
      <div class="Modal__cross-box _cross" @click="modalClose">
        <span class="Modal__cross" />
      </div>
      <div class="Modal_inner Explanation__modal_inner Explanation__modal_inner--pd_lr">
        <div class="Explanation__class">
          <ul class="Explanation__class_list">
            <li class="Explanation__class_list_item">
              <div class="Explanation__class_list_sub">
                <img class="Explanation__class_list_sub_img" alt="SLEEP" src="assets/img/ph_lesson05.jpg"><span>SLEEP</span>
              </div>
              <div class="Explanation__class_list_main">
                <img class="Explanation__class_list_main_img" alt="" src="assets/img/icon_lesson06.png">
                <p>寝つきが悪かったり、眠りが浅い方のために、睡眠の質を高めるためのプログラムです。ボディスキャンなどの方法で身体からのメッセージに耳を傾け、深いリラクゼーションに導きます。</p>
              </div>
            </li>
            <li class="Explanation__class_list_item">
              <div class="Explanation__class_list_sub">
                <img class="Explanation__class_list_sub_img" alt="RELAX" src="assets/img/ph_lesson06.jpg"><span>RELAX</span>
              </div>
              <div class="Explanation__class_list_main">
                <img class="Explanation__class_list_main_img" alt="" src="assets/img/icon_lesson07.png">
                <p>心も身体もおつかれの方のためのプログラムです。ストレッチや呼吸法などを取り入れて、終わった後にのんびりリラックスを味わえるプログラムです。おやすみ前にもおすすめです。</p>
              </div>
            </li>
            <li class="Explanation__class_list_item">
              <div class="Explanation__class_list_sub">
                <img class="Explanation__class_list_sub_img" alt="YOGA NIDRA" src="assets/img/ph_lesson07.jpg"><span>YOGA NIDRA</span>
              </div>
              <div class="Explanation__class_list_main">
                <img class="Explanation__class_list_main_img" alt="" src="assets/img/icon_lesson08.png">
                <p>ヨガニドラは寝る瞑想と呼ばれ、身体と心の緊張状態をほぐし深いリラックス状態にうながす効果があります。ベッドや床に横たわった姿勢での受講をおすすめします。</p>
              </div>
            </li>
            <li class="Explanation__class_list_item">
              <div class="Explanation__class_list_sub">
                <img class="Explanation__class_list_sub_img" alt="BODY CARE" src="assets/img/ph_lesson08.jpg"><span>BODY CARE</span>
              </div>
              <div class="Explanation__class_list_main">
                <img class="Explanation__class_list_main_img" alt="" src="assets/img/icon_lesson09.png">
                <p>毎日休みなく働いているあなたの身体をいたわるためのプログラムです。ストレッチやセルフマッサージなどを取り入れて、ご自身の身体をセルフケアしていきましょう。</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </modal-layout>
</template>

<script>
import ModalLayout from '@/views/components/modals/ModalLayout.vue'

export default {
  name: 'Recommend02',
  components: { ModalLayout },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    modalClose() {
      this.$emit('close')
    }
  }
}
</script>
